<template>
    <div
      class="article_rows-item"
      v-if="field"
    >
        <div
          v-if="!field.showEdit"
          class="article_rows-item"
        >
          <v-radio
            :label="'Статья ' + articleItem.number"
            :value="articleItem.id"
            @change="changeArticle(articleItem)"
          ></v-radio>
<!--          <span-->
<!--            class="pro-icon-pencil article_rows-item-pencil"-->
<!--            @click="changeFieldShow(true)"-->
<!--          />-->

          <span
            v-if="!articleItem.norms_count"
            class="article_rows-item-remove"
            @click="removeArticle"
          >
            <i class="fa fa-trash" aria-hidden="true"></i>
          </span>
<!--          <span-->
<!--            class="article_rows-item-cancel"-->
<!--            @click="cancelArticle"-->
<!--          >-->
<!--            <i class="fa fa-redo" aria-hidden="true"></i>-->
<!--          </span>-->
      </div>
      <div
        v-else
        class="article_rows-item"
      >
        <InlineEditNorm
          :params="field"
          @update-field="update($event)"
        />
      </div>
    </div>
</template>
<script>

import InlineEditNorm from '@/components/law/InlineEditNorm.vue'
import LAW from '@/model/law'

export default {
  name: 'LawNormFormArticle',
  components: { InlineEditNorm },
  props: {
    articleItem: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      field: null
    }
  },

  mounted () {
    this.getField();
  },

  methods: {
    changeArticle(article) {
      this.$emit('change', article)
    },

    // cancelArticle() {
    //   this.$emit('cancel')
    // },

    removeArticle() {
      LAW.removeArticle({
        id: this.articleItem.id
      }).then((response) => {
        this.$emit('remove', this.articleItem.id)
      }).catch((error) => {
        console.log(error.message)
      })
    },
    //
    // changeFieldShow(value) {
    //   this.field.showEdit = value
    // },

    update(data ) {
      if (data.status) {
        this.articleItem.number = data.value;
        LAW.editLawArticle(this.articleItem).then((response) => {
          this.articleItem = response.data
        }).catch((error) => {})
      }

      this.field.showEdit = false
    },

    getField() {
      this.field = {
        name: 'number',
        showEdit: false,
        fields: [
          {
            name: 'number',
            label: this.$i18n.t('Номер статьи'),
            value: this.articleItem.number,
            type: 'article'
          }
        ],
      }
    }
  }
}
</script>
<style lang="scss">
  .article_rows {

    &-item {
      padding-top: 10px;
      display: flex;
      width: 100%;

      .v-label {
        padding: 0 !important;
      }

      &-pencil {
       margin-left: 10px;
       cursor: pointer;
       display: flex;
       align-items: center;
      }

      &-remove {
        margin-left: 10px;
        cursor: pointer;
      }
      &-cancel {
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }
</style>
